import { useEffect } from "react";
import { Outlet, useMatch } from "react-router-dom";
import { startCase } from "lodash";

import SidebarLayout from "components/SidebarLayout";
import SettingsSidebar from "components/sidebar/SettingsSidebar";
import setPageTitle from "helpers/title";

export default function SettingsLayout() {
  const section = useMatch("/settings/:item/*")?.params.item ?? null;

  useEffect(() => {
    setPageTitle(section ? startCase(section) : "System Settings");
  }, [section]);

  return (
    <SidebarLayout
      sidebar={<SettingsSidebar />}
      content={<Outlet />}
      mobileMenuLabel="Settings Navigation"
    />
  );
}
